import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  COURSE_PAUSE_MODAL_STAGES,
  selectedRequestSelector,
  selectedSbatLectureSelector,
  setCoursePauseManageModalStage,
  setSelectedSbatLecture,
  setSelectedSuperBatch,
  useScheduleResumeMutation,
} from 'features/courseResume';
import GlobalLoader from 'components/GlobalLoader';
import styles from './ScheduleResumeButton.module.scss';

function ScheduleResumeButton() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const selectedSbatLecture = useSelector(selectedSbatLectureSelector);
  const [scheduleResume, { isSuccess, error, isLoading: isUpdating }] =
    useScheduleResumeMutation();

  const handleScheduleResume = useCallback(() => {
    scheduleResume({
      requestId: selectedRequest.id,
      toSbatId: selectedSbatLecture?.id,
    });
  }, [scheduleResume, selectedRequest.id, selectedSbatLecture?.id]);

  useEffect(() => {
    if (isSuccess) {
      batch(() => {
        dispatch(setSelectedSbatLecture(null));
        dispatch(setSelectedSuperBatch(null));
        dispatch(
          setCoursePauseManageModalStage(COURSE_PAUSE_MODAL_STAGES.success)
        );
      });
      cogoToast.success('Successfully updated the request.');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  return (
    <div className={styles.root}>
      <GlobalLoader isVisible={isUpdating} />
      <Tappable
        onClick={handleScheduleResume}
        disabled={isUpdating || !selectedSbatLecture}
        className={classNames('btn btn-primary', styles.button)}
      >
        Schedule Resume
      </Tappable>
    </div>
  );
}

export default ScheduleResumeButton;
